export default __webpack_public_path__ + "static/media/WhatsApp Community_Foha.ac2a27d0.jpeg";